<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { SENTIMENT_STYLES, getConversationSentiment } from './sentiment';

const props = defineProps({
  conversation: { type: Object, required: true },
  size: {
    type: String,
    default: 'sm',
    validator: value => ['xs', 'sm'].includes(value),
  },
  iconOnly: { type: Boolean, default: false },
});

const { t } = useI18n();

const sentiment = computed(() => getConversationSentiment(props.conversation));
const style = computed(() => SENTIMENT_STYLES[sentiment.value]);
const label = computed(() => (style.value ? t(style.value.label) : ''));
</script>

<template>
  <span
    v-if="style"
    v-tooltip.top="
      iconOnly ? `${t('MULTICHAT.SENTIMENT.TITLE')}: ${label}` : ''
    "
    class="inline-flex items-center flex-shrink-0 gap-1 font-medium rounded-md"
    :class="[
      style.badgeClass,
      size === 'xs' ? 'h-[18px] px-1 text-[10px]' : 'h-5 px-1.5 text-[11px]',
    ]"
  >
    <span :class="[style.icon, size === 'xs' ? 'size-3' : 'size-3.5']" />
    <span v-if="!iconOnly">{{ label }}</span>
  </span>
</template>
